import Users from "../pages/admin/Users";
import Members from "../pages/admin/Members";
import Updateprofile from "../pages/Company/Updateprofile";
import ViewProfile from "../pages/Company/ViewProfile";
import ListShipment from "../pages/shipment/listShipment";
import AddShipment from "../pages/shipment/addShipment";
import PendingMembers from "../pages/admin/PendingMembers";
import DashboardPage from "../pages/DashboardPage";
import ManageServices from "../pages/admin/ManageServices";
import ManageCities from "../pages/admin/ManageCities";
import ManageHsCodes from "../pages/admin/ManageHsCodes";
import ManageCountries from "../pages/admin/ManageCountries";
import ManageIndustries from "../pages/admin/ManageIndustries";
import ManageCertificates from "../pages/admin/ManageCertificates";
import ManagePorts from "../pages/admin/ManagePorts";
import SubscriptionPlans from "../pages/admin/subscriptionPlans";
import BuyerSupplier from "../pages/admin/BuyerSupplier";
import LogisticsMembers from "../pages/admin/logisticsMembers";
import ManageLeads from "../pages/admin/ManageLeads";
import ShipmentDetail from "../pages/shipment/shipmentDetail";
import PrekycDashboard from "../pages/admin/preKYC/PrekycDashboard";
import AllInquiries from "../pages/admin/AllInquiries";
import MyInquiries from "../pages/admin/MyInquiries";
import MemberDetailsForm from "../pages/admin/MemberDetailsForm";
import UserSettings from "../pages/Company/UserSettings";
import ChangePassword from "../pages/Company/ChangePassword";
import ProfileHistory from "../pages/admin/ProfileHistory";
import ManageRoles from "../pages/admin/ManageRoles";
import PaidMembers from "../pages/admin/PaidMembers";
import MockInquiries from "../pages/admin/MockInquiries";
import MockInquiryView from "../pages/admin/MockInquiryView";


const MENU_ROUTES = {
    UPDATE_COMPANY_PROFILE: '/updateprofile/:id',
    USERS: '/users',
    MEMBERS: '/members',
    COMPANY_VIEW_PROFILE: "/company/:id",
    SHIPMENTS: "/shipments",
    ADD_SHIPMENT: "/shipment/add",
    PENDING_MEMBER_LIST: "/pending-requests",
    DASHBOARD: "/dashboard",
    MANAGE_SERVICES: "/manage-services/:service_status",
    MANAGE_CITIES: "/manage-cities/:city_status",
    MANAGE_HS_CODES: "/manage-hs-codes/:hs_code_status",
    MANAGE_COUNTRIES: "/manage-countries",
    MANAGE_INDUSTRIES: "/manage-industries/:industry_status",
    MANAGE_CERTIFICATES: "/manage-certificates",
    MANAGE_PORTS: "/manage-ports/:port_status",
    SUBSCRIPTION_PLANS: "/subscription-plans",
    SHIPMENT_COMPANY_LIST: "/buyer-supplier",
    LOGISTICS_MEMEBRS: "/logistics-members",
    MANAGE_LEADS: "/manage-leads",
    TRADE_DETAIL: "/trade-detail/:type/:company_name",
    PRE_KYC_DASHBOARD: "/landing-dashboard",
    ALL_INQUIRIES: "/all-inquiries/:for?",
    MY_INQUIRIES: "/my-inquiries",
    MEMBERS_FORM: "/member-form",
    LOG_VIEW_PROFILE: "/logistic-company/:id",
    USER_SETTINGS: "/user-settings",
    CHANGE_PSWD: "/change-password",
    PROFILE_HISTORY: "/profile-history/:id",
    MANAGE_ROLES: "/manage-roles",
    PAID_MEMBERS: "/paid-members",
    MOCK_INQUIRIES: "/mock-inquiries",
    MOCK_INQUIRY_VIEW:"/mock-inquiry-view/:id"
};

const MENU_ROUTES_COMPONENTS = [{
    pathname: 'UPDATE_COMPANY_PROFILE',
    path: '/updateprofile/:id',
    element: <Updateprofile />
}, {
    pathname: 'USERS',
    path: '/users',
    element: <Users />
}, {
    pathname: 'MEMBERS',
    path: '/members',
    element: <Members />
},
{
    pathname: "COMPANY_VIEW_PROFILE",
    path: "/company/:id",
    element: <ViewProfile />
},
{
    pathname: "SHIPMENTS",
    path: "/shipments",
    element: <ListShipment />
},
{
    pathname: "ADD_SHIPMENT",
    path: "/shipment/add",
    element: <AddShipment />
}, {
    pathname: "PENDING_MEMBER_LIST",
    path: "/pending-requests",
    element: <PendingMembers />
},
{
    pathname: "DASHBOARD",
    path: "/dashboard",
    element: <DashboardPage />

},
{
    pathname: 'MANAGE_SERVICES',
    path: '/manage-services/:service_status',
    element: <ManageServices />
},
{
    pathname: 'MANAGE_CITIES',
    path: '/manage-cities/:city_status',
    element: <ManageCities />
},
{
    pathname: 'MANAGE_HS_CODES',
    path: '/manage-hs-codes/:hs_code_status',
    element: <ManageHsCodes />
},
{
    pathname: 'MANAGE_COUNTRIES',
    path: '/manage-countries',
    element: <ManageCountries />
},
{
    pathname: 'MANAGE_INDUSTRIES',
    path: '/manage-industries/:industry_status',
    element: <ManageIndustries />
},
{
    pathname: 'MANAGE_CERTIFICATES',
    path: '/manage-certificates',
    element: <ManageCertificates />
},
{
    pathname: 'MANAGE_PORTS',
    path: '/manage-ports/:port_status',
    element: <ManagePorts />
},
{
    pathname: "SUBSCRIPTION_PLANS",
    path: "/subscription-plans",
    element: <SubscriptionPlans />
},
{
    pathname: "SHIPMENT_COMPANY_LIST",
    path: "/buyer-supplier",
    element: <BuyerSupplier />
},
{
    pathname: "LOGISTICS_MEMEBRS",
    path: "/logistics-members",
    element: <LogisticsMembers />
},
{
    pathname: "MANAGE_LEADS",
    path: "/manage-leads",
    element: <ManageLeads />
},
{
    pathname: "TRADE_DETAIL",
    path: "/trade-detail/:type/:company_name",
    element: <ShipmentDetail />
},
{
    pathname: "PRE_KYC_DASHBOARD",
    path: "/landing-dashboard",
    element: <PrekycDashboard />
},
{
    pathname: "ALL_INQUIRIES",
    path: "/all-inquiries/:fordate?",
    element: <AllInquiries />
},
{
    pathname: "MY_INQUIRIES",
    path: "/my-inquiries",
    element: <MyInquiries />
},
{
    pathname: "MEMBERS_FORM",
    path: "/member-form",
    element: <MemberDetailsForm />
},
{
    pathname: "LOG_VIEW_PROFILE",
    path: "/logistic-company/:id",
    element: <ViewProfile />
}, {
    pathname: "USER_SETTINGS",
    path: "/user-settings",
    element: <UserSettings />
}, {
    pathname: "CHANGE_PSWD",
    path: "/change-password",
    element: <ChangePassword />
},
{
    pathname: "PROFILE_HISTORY",
    path: "/profile-history/:id",
    element: <ProfileHistory />
},
{
    pathname: "MANAGE_ROLES",
    path: "/manage-roles",
    element: <ManageRoles />
}, {
    pathname: "PAID_MEMBERS",
    path: "/paid-members",
    element: <PaidMembers />
}, {
    pathname: "MOCK_INQUIRIES",
    path: "/mock-inquiries",
    element: <MockInquiries />
}, {
    pathname: "MOCK_INQUIRY_VIEW",
    path: "/mock-inquiry-view/:id",
    element: <MockInquiryView />
}



]

export { MENU_ROUTES, MENU_ROUTES_COMPONENTS };
